import { FC } from 'react';
import FontHeading3 from '../../../../components/fonts/font-heading3/font-heading3';
import { FONT_COLOR, FONT_VARIANT } from '../../../../components/fonts/font-props';
import FontBody1 from '../../../../components/fonts/font-body1/font-body1';
import { Button } from '../../../../components/inputs/button/button';
import { BUTTON_VARIANTS } from '../../../../components/inputs/button-variants';
import { Checkbox } from '../../../../components/inputs/checkbox/checkbox';
import useDashboardTranslation from '../../../../dashboard-translation/hooks/dashboard-translation-hook';
import './terms-acceptance-shared.scss';
import './terms-acceptance-modal.scss';

const TRANSLATION_SCOPE = 'dashboard-onboarding';

export interface ITermsAcceptanceModalContentProps {
    termsContent: string;
    isChecked: boolean;
    isSubmitting: boolean;
    onCheckedChange: (checked: boolean) => void;
    onAcceptClick: () => void;
}

const TermsAcceptanceModalContent: FC<ITermsAcceptanceModalContentProps> = ({
    termsContent,
    isChecked,
    isSubmitting,
    onCheckedChange,
    onAcceptClick,
}) => {
    const { getTranslation } = useDashboardTranslation();

    return (
        <div
            className="terms-acceptance-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="terms-acceptance-modal-title"
            tabIndex={-1}
        >
            <div className="terms-acceptance-modal__content">
                <div id="terms-acceptance-modal-title" className="terms-acceptance-modal__title">
                    <FontHeading3 color={FONT_COLOR.NEUTRAL11_MENU} variant={[FONT_VARIANT.BOLD]}>
                        {getTranslation('TERMS_ACCEPTANCE_TITLE', TRANSLATION_SCOPE)}
                    </FontHeading3>
                </div>
                <div className="terms-acceptance-terms-box" aria-label="Terms and conditions">
                    <pre className="terms-acceptance-terms-text">{termsContent}</pre>
                </div>
                <div className="terms-acceptance-checkbox">
                    <Checkbox
                        label={
                            <FontBody1 color={FONT_COLOR.NEUTRAL11_MENU}>
                                {getTranslation('TERMS_ACCEPTANCE_CHECKBOX_LABEL', TRANSLATION_SCOPE)}
                            </FontBody1>
                        }
                        checked={isChecked}
                        onChange={onCheckedChange}
                        disabled={isSubmitting}
                    />
                </div>
                <div className="terms-acceptance-modal__actions-section">
                    <hr className="terms-acceptance-modal__divider" />
                    <div className="terms-acceptance-modal__actions">
                        <Button
                            text={getTranslation('TERMS_ACCEPTANCE_ACCEPT_BUTTON', TRANSLATION_SCOPE)}
                            variant={BUTTON_VARIANTS.Primary}
                            onClick={onAcceptClick}
                            disabled={!isChecked || isSubmitting}
                            hasLoader
                            isLoading={isSubmitting}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAcceptanceModalContent;
